module.exports = __webpack_public_path__ + "img/beijingqiche.a9102e40.png";